module.exports = __webpack_public_path__ + "assets/images/project/stylised-images/nomination-day-final-objections-deadline.jpg?v=86750765";